module.exports = __webpack_public_path__ + "img/land-logo.4d9d02be.png";